import { useState, useEffect } from "react";
import { branchProductWiseDeposits, branchWiseDeposits } from "./SavingService";
import { Card, Form, Row, Col, Select, Button, Spin, DatePicker } from 'antd';
import { errHandler } from '../../helper/helper';
import { getAllWasamsByBranchId } from "./SavingService";
import { disabledDate } from "../../Utils/Util";
import { exportProductSummaryWithPercentage } from "../../Utils/ExcelExportProductSummary";
import moment from 'moment';



const { Option, OptGroup } = Select;

const ProductWiseReports = ({
    loginPlaceId,
    products,
    districtData,
    districtName,
    branchId,
    wasamData,
}) => {

    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [availableBranches, setAvailableBranches] = useState([]);
    const [selectedBranches, setSelectedBranches] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [selectedDate, setSelectedDate] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedWasam, setSelectedWasam] = useState([]);
    const [selectedActiveStatus, setSelectedActiveStatus] = useState(null);


    const activeDormantAllStatus = [
        {
            value: 0,
            label: "Active accounts"
        },
        {
            value: 1,
            label: "Dormant accounts"
        },
        {
            value: 2,
            label: "All accounts"
        }
    ]


    // Update available branches based on selected districts
    useEffect(() => {
        const district = districtData.find(d => d.districtId === selectedDistrict);
        const filtered = district ? district.branchDtoList || [] : [];
        setAvailableBranches(filtered);

        setSelectedBranches(prev =>
            prev.filter(bid => filtered.some(b => b.id === bid))
        );
    }, [selectedDistrict, districtData]);





    const handleExport = async () => {
        setLoading(true);

        try {
            let responseData = null;

            // Fetch data based on loginPlaceId
            if (loginPlaceId === "1") {
                responseData = await getBranchProductWiseDeposits();
            } else if (loginPlaceId === "3" || loginPlaceId === "4") {
                responseData = await getBranchWiseDeposits();
            }

            const exportData = responseData?.data?.dataList || [];
            const hasData = exportData.length > 0;

            if (!hasData) {
                console.warn("No data available to export.");
                return;
            }

            const dateTimeNow = moment().format('YYYY-MM-DD_HH-mm-ss');
            const isBranch = loginPlaceId === "1";
            const groupByField = isBranch ? 'gnName' : 'branchName';

            const sheetName = "Product Summary";
            const branchOrDistrictName = isBranch ? responseData?.data?.branchName : responseData?.data?.districtName

            const date = moment(selectedDate).format('YYYY-MM-DD')
            const activeStatus = (selectedActiveStatus == 0) ? "Active Accounts" : (selectedActiveStatus == 1) ? "Dormant Accounts" : "All Accounts"

            // Export the Excel file
            exportProductSummaryWithPercentage({
                data: exportData,
                fileName: `${branchOrDistrictName}_Product_summary${dateTimeNow}.xlsx`,
                groupByField: groupByField,
                sheetName: sheetName,
                branchOrDistrictName: branchOrDistrictName,
                formattedDate: date,
                activeStatus: activeStatus,
                loginPlaceId: loginPlaceId

            });

        } catch (error) {
            console.error("Export failed:", error);
        } finally {
            setLoading(false);
        }
    };


    const getBranchProductWiseDeposits = async () => {

        let data = {
            branchId: branchId,
            productIdList: selectedProducts,
            selectedDate: selectedDate,
            activeStatus: selectedActiveStatus,
            gnIdList: selectedWasam
        }
        try {
            const res = await branchProductWiseDeposits(data);
            return res; // ✅ Now you're returning it from getDistrictData
        } catch (err) {
            errHandler(err);
            throw err; // optionally rethrow so caller knows it failed
        }
    }
    const getBranchWiseDeposits = async () => {

        let data = {
            branchIdList: selectedBranches,
            productIdList: selectedProducts,
            selectedDate: selectedDate,
            activeStatus: selectedActiveStatus,
            districtId: selectedDistrict
        }
        try {
            const res = await branchWiseDeposits(data);
            return res; // ✅ Now you're returning it from getDistrictData
        } catch (err) {
            errHandler(err);
            throw err; // optionally rethrow so caller knows it failed
        }
    }





    return (
        <div className="panel-container">
            <Card hoverable className="inner-card">
                <Form layout="vertical">
                    <Row gutter={[16, 16]}>
                        {/* District auto complete */}
                        {(loginPlaceId === "3" || loginPlaceId === "4") && (
                            <Col span={24}>
                                <Form.Item label="Select Districts">
                                    <Select
                                        mode="single"
                                        placeholder="Select districts"
                                        style={{ width: '100%' }}
                                        value={selectedDistrict}
                                        onChange={setSelectedDistrict}
                                    >
                                        {districtData
                                            .filter(d => loginPlaceId === "4" ? d.districtName === districtName : true)
                                            .map(d => (
                                                <Option key={d.districtId} value={d.districtId}>
                                                    🏙️ {d.districtName}
                                                </Option>
                                            ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        )}
                        {(loginPlaceId === "3" || loginPlaceId === "4") && (
                            <Col span={24}>
                                <Form.Item label="Select Branch(es)">
                                    <Select
                                        mode="multiple"
                                        placeholder="Select branches"
                                        style={{ width: '100%' }}
                                        value={selectedBranches}
                                        onChange={(values) => {
                                            if (values.includes('ALL')) {
                                                setSelectedBranches(availableBranches.map(b => b.id));
                                            } else {
                                                setSelectedBranches(values);
                                            }
                                        }}
                                        disabled={availableBranches.length === 0}
                                    >
                                        <Option key="ALL" value="ALL">
                                            🔘 Select All Branches
                                        </Option>
                                        {availableBranches.map(branch => (
                                            <Option key={branch.id} value={branch.id}>
                                                🏢 {branch.branchName}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        )}
                        {loginPlaceId == "1" && (
                            <Col span={24}>
                                <Form.Item label="Wasam">
                                    <Select
                                        mode="multiple" value={selectedWasam} onChange={(values) => {
                                            if (values.includes('ALL')) {
                                                setSelectedWasam(wasamData.map(b => b.wastId));
                                            } else {
                                                setSelectedWasam(values);
                                            }
                                        }}
                                        disabled={wasamData.length === 0} style={{ width: '100%' }}>
                                        <Option value="ALL">All Wasam</Option>
                                        {wasamData.map((wasam) => (
                                            <Option key={wasam.wastId} value={wasam.wastId}>
                                                🏙️  {wasam.wasName}--{wasam.wasName}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        )}

                        <Col span={24}>
                            <Form.Item label="Select Date">
                                <DatePicker onChange={(date) => setSelectedDate(date)} disabledDate={disabledDate} style={{ width: '100%' }} />
                            </Form.Item>
                        </Col>

                        {/* Multi-select product */}
                        <Col span={24}>
                            <Form.Item label="Select Products">
                                <Select
                                    mode="multiple"
                                    allowClear
                                    placeholder="Select products"
                                    style={{ width: '100%' }}
                                    value={selectedProducts}
                                    onChange={(values) => {
                                        if (values.includes('ALL')) {
                                            setSelectedProducts(products.map(b => b.productId));
                                        } else {
                                            setSelectedProducts(values);
                                        }
                                    }}
                                    disabled={products.length === 0}
                                // onChange={setSelectedProducts}
                                >
                                    <Option key="ALL" value="ALL">
                                        🔘 Select All Products
                                    </Option>
                                    {products.map(product => (
                                        <Option key={product.productId} value={product.productId}>
                                            {product.productName}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item label="Active">
                                <Select
                                    style={{ width: '100%' }}
                                    onChange={(value) => setSelectedActiveStatus(value)}
                                    options={activeDormantAllStatus}>
                                </Select>
                            </Form.Item>
                        </Col>

                        {/* Submit button */}
                        <Col span={24}>
                            <Form.Item className="generate-btn-outline">
                                <Button
                                    onClick={handleExport}
                                    disabled={loading}
                                    className="generate-btn"
                                    style={{ textAlign: 'right' }}
                                >
                                    {loading ? <Spin /> : 'Generate Report'}
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </div>
    );


}
export default ProductWiseReports